var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, reaction } from "mobx";
import { routeEquals } from "./RoutingUIManager";
import { NamedRoutes } from "./NamedRoutes";
import { assertUserTypeOptional } from "healthex-common/checkusertype";
import { UserType } from "healthex-common/user.dtos";
import { isAndroid, isIOS } from "react-device-detect";
import { NOT_LOADED } from "../Infra/RemoteData";
export class RedirectToPatientPortalEmbedUIManager {
    constructor(routingUIManager, provisioningService) {
        this.routingUIManager = routingUIManager;
        this.provisioningService = provisioningService;
        this.healthcareOrganization = NOT_LOADED;
        this.mobileAppShouldHaveLaunched = false;
        this.appInstallURL = NOT_LOADED;
        reaction(() => this.routingUIManager.currentRoute, () => {
            var _a;
            if (((_a = this.routingUIManager.currentRoute) === null || _a === void 0 ? void 0 : _a.routeName) === NamedRoutes.LOGIN_REDIRECT_TO_EMBED.routeName) {
                void this.launchEmbed();
            }
        }, { equals: routeEquals });
    }
    async launchEmbed(forceWeb = false) {
        var _a;
        this.mobileAppShouldHaveLaunched = false;
        const organizationId = (_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.organizationId;
        if (!organizationId)
            return;
        this.healthcareOrganization = NOT_LOADED;
        this.healthcareOrganization = assertUserTypeOptional(await this.provisioningService.getOrganizationPublicProfileById(organizationId), UserType.HEALTHCARE_ORGANIZATION);
        if (!this.healthcareOrganization || this.healthcareOrganization === NOT_LOADED)
            return;
        const { launchURL, mobileApp, appInstallURL } = this.getUrls(this.healthcareOrganization, forceWeb);
        if (!launchURL)
            return;
        this.appInstallURL = appInstallURL;
        window.location.href = launchURL;
        if (mobileApp) {
            window.setTimeout(() => (this.mobileAppShouldHaveLaunched = true), 3000);
        }
    }
    getUrls(organization, forceWeb) {
        if (isIOS && !forceWeb) {
            return {
                launchURL: organization.patientPortalMobileAppLaunchUrl,
                appInstallURL: organization.patientPortalIosAppInstallUrl,
                mobileApp: true,
            };
        }
        else if (isAndroid && !forceWeb) {
            return {
                launchURL: organization.patientPortalMobileAppLaunchUrl,
                appInstallURL: organization.patientPortalAndroidAppInstallUrl,
                mobileApp: true,
            };
        }
        else {
            return { launchURL: organization.patientPortalWebLaunchUrl, appInstallURL: null, mobileApp: false };
        }
    }
}
__decorate([
    observable
], RedirectToPatientPortalEmbedUIManager.prototype, "healthcareOrganization", void 0);
__decorate([
    observable
], RedirectToPatientPortalEmbedUIManager.prototype, "mobileAppShouldHaveLaunched", void 0);
__decorate([
    observable
], RedirectToPatientPortalEmbedUIManager.prototype, "appInstallURL", void 0);
